import { Inject, Injectable } from '@angular/core';
import { Articolo } from '@models/articolo.model';
import { NgxCrudService } from '@sinapsys/ngx-crud';
import { INTESTAZIONE_CARICAMENTO } from './caricamento.interceptor';
import { Observable, map } from 'rxjs';
import { COMMON_APP_CONFIG } from '../tokens/common-config.token';

@Injectable({
  providedIn: 'root',
})
export class ArticoliService extends NgxCrudService<Articolo, number> {
  constructor(@Inject(COMMON_APP_CONFIG) private mainConfig: Required<{ api: { apiBaseUrl: string } }>) {
    super({ apiBaseUrl: '' });
    this._baseUrl += this.mainConfig.api.apiBaseUrl + 'gestione-articoli/articoli/';
  }

  /**
   * Salvataggio automatico della bozza.
   *
   * Manda solo il corpo del lavoro in corso — titolo, testo, keywords — e non
   * tocca lo stato di pubblicazione ne' la data: quelle sono decisioni della
   * redazione, non effetti collaterali di un salvataggio che parte da solo.
   *
   * Silenzioso di proposito: e' rumore di fondo, non un'azione chiesta.
   */
  salvaBozza(id: number, dati: { titolo?: string; testo?: string; keywords?: string }): Observable<Articolo> {
    return this.http.put<Articolo>(`${this._baseUrl}${id}/bozza`, dati, {
      responseType: 'json',
      withCredentials: true,
      headers: { [INTESTAZIONE_CARICAMENTO]: 'silenzioso' },
    });
  }

  getAutocomplete(sq: string): Observable<Articolo[]> {
    return this.search({ $or: { titolo: { $like: sq } } }).pipe(
      map((c) => c.items.map((c) => new Articolo(c)))
    );
  }
}
